module.exports = __webpack_public_path__ + "static/img/point.216dd25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/point.png
// module id = dyrn
// module chunks = 2